<script setup lang="ts">
import { Subscription } from '@nuts/auto-delivery-sdk';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

import BaseBodyText from '@/components/base/typography/BaseBodyText.vue';
import SmallBodyText from '@/components/base/typography/SmallBodyText.vue';
import { pluralizeBy } from '@/filters/pluralize';
import { getAutoDeliveryDetailsPath } from '@/utils/autoDelivery';

dayjs.extend(advancedFormat);

defineProps<{ subscription: Subscription }>();
</script>

<template>
  <div class="flex justify-between p-4 rounded-lg bg-nuts-cyan-200">
    <div class="flex flex-col gap-1">
      <BaseBodyText class="font-semibold" data-test="auto-delivery-active-message"
        >Auto-Delivery Active For This Product</BaseBodyText
      >
      <SmallBodyText class="text-neutral-700" data-test="auto-delivery-active-message-next-date">
        Next delivery on
        {{ dayjs(subscription.nextShipOn).format('MMMM Do') }},
        <template v-if="subscription.interval">
          ships every
          {{ subscription.interval / 7 }}
          {{ pluralizeBy('week', subscription.interval / 7) }}
        </template>
        <template v-else>one time</template>.
      </SmallBodyText>
    </div>
    <RouterLink
      class="flex h-min"
      :to="getAutoDeliveryDetailsPath(subscription)"
      data-test="auto-delivery-notice-manage-link"
    >
      <SmallBodyText class="underline text-nuts-cyan-700">
        Manage
        <span class="sr-only">existing auto-delivery for this product</span>
      </SmallBodyText>
    </RouterLink>
  </div>
</template>
